/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import DialogConfirm from "@jumbo/components/JumboDialog/components/DialogConfirm";

import Stack from "@mui/material/Stack";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import Div from "@jumbo/shared/Div";
import { deleteUser, getUserList } from "app/redux/slice/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import Loader from "@jumbo/components/Loader";
import ClearIcon from "@mui/icons-material/Clear";
import { userType } from "app/helpers/userType";
import { userAttendanceLogById, userEditById, USERS_ADD } from "app/routes/constant";
import { getRoleList } from "app/redux/slice/roleSlice";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";
import { FormatListBulleted } from "@mui/icons-material";

const User = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { isMA } = userType();

  const userData = useSelector((state) => state?.user);
  const [searchText, setSearchText] = useState(
    () => localStorage.getItem("user-search") || ""
  );
  const [order, setOrder] = useState(
    () => localStorage.getItem("user-order") || "desc"
  );
  const [orderBy, setOrderBy] = useState(
    () => localStorage.getItem("user-orderBy") || "createdAt"
  );
  const [roleId, setRoleId] = useState(() => {
    try {
      const savedRole = localStorage.getItem("user-role");
      return savedRole ? JSON.parse(savedRole) : undefined;
    } catch (e) {
      return undefined;
    }
  });
  const roleData = useSelector((state) => state?.role);

  const {
    isOpen: isDelete,
    onClose: closeDelete,
    actionProps: deleteActionProps,
    stageAction: deleteStageAction,
  } = useDisclosure();
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "user" });
  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission"))
  );

  const [permission, setPermission] = useState({
    createPermission: false,
    updatePermission: false,
    deletePermission: false,
  });
  const getPermission = () => {
    if (isMA) {
      setPermission({
        createPermission: true,
        updatePermission: true,
        deletePermission: true,
      });
    } else {
      let permissionValue = {
        createPermission: false,
        updatePermission: false,
        deletePermission: false,
      };
      const rolePermission = permissionData;
      rolePermission?.length &&
        rolePermission.forEach(function (num) {
          if (num?.name === "user-create") {
            permissionValue.createPermission = true;
          }
          if (num?.name === "user-delete") {
            permissionValue.deletePermission = true;
          }
          if (num?.name === "user-update") {
            permissionValue.updatePermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };
  useEffect(() => {
    getPermission();
  }, []);
  const columns = [
    { id: "name", label: "Name", sort: true },
    {
      id: "role.name",
      label: "Role",
      sort: true,
      render: (row) => row?.role?.name,
    },
    { id: "email", label: "Email", sort: true },
    { id: "mobileNumber", label: "Mobile Number", sort: true, minWidth: 145 },
    {
      id: "actions",
      label: "Actions",
      align: "right",
      minWidth: 100,
      render: (row) => (
        <>
          {permission.updatePermission && (
            <IconButton
              onClick={() => {
                navigate(userEditById(row._id));
              }}
            >
              <EditIcon />
            </IconButton>
          )}
          <Tooltip title="Attendance Logs List">
            <IconButton
              onClick={() => {
                navigate(userAttendanceLogById(row._id));
              }}
            >
              <FormatListBulleted />
            </IconButton>
          </Tooltip>
          {permission.deletePermission && (
            <IconButton
              onClick={() => {
                deleteStageAction(row);
              }}
            >
              <DeleteIcon color={"error"} />
            </IconButton>
          )}
        </>
      ),
    },
  ];

  const DeleteUser = () => {
    dispatch(deleteUser(deleteActionProps?._id))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
          closeDelete();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  const getData = () => {
    localStorage.setItem("user-search", searchText.trim());
    if (roleId) {
      localStorage.setItem("user-role", JSON.stringify(roleId));
    } else {
      localStorage.removeItem("user-role");
    }
    localStorage.setItem("user-order", order);
    localStorage.setItem("user-orderBy", orderBy);
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
      ...(roleId && { roleId: roleId._id }),
      ...(orderBy && { sort: order === "asc" ? 1 : -1, field: orderBy }),
    };
    dispatch(getUserList(value));
  };

  useEffect(() => {
    dispatch(getRoleList());
  }, []);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0, 0);
      getData();
    }
  };
  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
    localStorage.setItem("user-order", Order);
    localStorage.setItem("user-orderBy", OrderBy);
  };
  return (
    <>
      {userData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => {
                              setSearchText("");
                              localStorage.removeItem("user-search");
                            }}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <JumboAutoComplete
                      options={roleData?.list || []}
                      label="Role"
                      size="small"
                      getOptionLabel={(option) => option?.name}
                      name={`roleId`}
                      value={roleId}
                      onChange={(evt, value) => {
                        setRoleId(value);
                        if (value) {
                          localStorage.setItem(
                            "user-role",
                            JSON.stringify(value)
                          );
                        } else {
                          localStorage.removeItem("user-role");
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Users List
                </Typography>
                {permission.createPermission && (
                  <LoadingButton
                    onClick={() => {
                      navigate(USERS_ADD);
                    }}
                    sx={{
                      mt: { xs: 1, md: 0 },
                    }}
                    type="submit"
                    variant="contained"
                  >
                    Add user
                  </LoadingButton>
                )}
              </Stack>
              <Table
                columns={columns}
                rows={userData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                count={userData?.total}
                Order={order}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </CardContent>
          </Card>
          <DialogConfirm
            isOpen={isDelete}
            onClose={closeDelete}
            title="Are you sure you want to delete this user?"
            onConfirm={DeleteUser}
            btnLabels={{ cancel: "Cancel", confirm: "Delete" }}
          />
        </>
      )}
    </>
  );
};

export default User;
